import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  count?: number[];
  name: LangType[];
}

export const useTasksByZone = (): ChartProps => {
  const { t, getLocale } = useLang();

  const { list } = useDashboardStore();
  const data = list?.most_loaded_qrs as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data?.count) {
      const isDataExist = data.count.some((count) => count > 0);

      return {
        series: isDataExist ? [{ data: data.count }] : [],
        options: {
          chart: {
            type: 'bar',
            width: '100%',
            toolbar: {
              show: false,
            },
          },
          grid: {
            show: false,
            padding: {
              left: -14,
              right: -14,
              bottom: -14,
              top: 10,
            },
          },
          plotOptions: {
            bar: {
              barHeight: 8,
              borderRadius: 4,
              distributed: true,
              horizontal: true,
              colors: {
                backgroundBarColors: ['#F2F2F2'],
                backgroundBarRadius: 4,
              },
              dataLabels: {
                position: 'bottom',
                maxItems: 10,
              },
            },
          },
          dataLabels: {
            enabled: true,
            textAnchor: 'start',
            style: {
              colors: ['#000'],
              fontSize: '14px',
              fontWeight: 'normal',
            },
            formatter: function (val, opt) {
              return opt.w.globals.labels[opt.dataPointIndex] + ' (' + val + ')';
            },
            offsetY: -16,
            offsetX: -10,
          },
          stroke: {
            width: 0,
            colors: ['#fff'],
          },
          xaxis: {
            categories: data.name.map((name) => getLocale(name)),
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            labels: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          annotations: {
            texts: [
              {
                text: t('Название QR (Кол-во задач)'),
                fontSize: 12,
                x: 0,
                y: 20,
                textAnchor: 'start',
                borderColor: 'transparent',
                foreColor: '#828282',
                fontWeight: 400,
              },
            ],
          },
          colors: ['#92BFFF'],
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, t, getLocale]);

  return {
    series: chartData.series,
    options: chartData.options,
    type: 'bar',
    label: 'Самые загруженные QR',
    subLabel:
      'Количество задач по каждому QR-коду, которые были созданы за указанный промежуток времени',
    wrapped: true,
  };
};
